import type { CacheProvider } from "./types";

export const CACHE_TTL = 3600000; // 1 hour in milliseconds

export const getCacheExpiry = (): number => Date.now() + CACHE_TTL;

export const COMMON_CACHE_KEYS = {
  user: "cache:user",
  accessToken: "cache:accessToken",
  refreshToken: "cache:refreshToken",
  /** Set instead of `refreshToken` when the refresh token lives in an HttpOnly cookie: holds its expiry, never the token. */
  refreshCookie: "cache:refreshCookie",
  theme: "cache:theme",
} as const;

export const cachedQuery = async <T>(cache: CacheProvider, key: string, fetchFn: () => Promise<T>): Promise<T> => {
  const cached = cache.get<T>(key);
  if (cached !== null) {
    return cached;
  }
  const result = await fetchFn();
  cache.set(key, result, getCacheExpiry());
  return result;
};
